import styled from 'styled-components'
import {deviceMax} from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Button from '../Button/Button'
import Search from '../../images/icons/search-black.svg'
import {MainContainer} from '../../theme/mainContainer.styled'

export const StyledContainer = styled.div`
  width: 100%;
  background-color: ${({theme}) => theme.colors.unique.black};
`

export const StyledSearchBar = styled(MainContainer)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: ${pxToRem(40)} 0;
  @media ${deviceMax.tablet} {
    padding: ${pxToRem(20)} ${pxToRem(10)};
    height: auto;
    margin-bottom: 0;
  }
`

export const StyledChildrenContainer = styled.div`
  width: 100%;
  display: none;
  @media ${deviceMax.tablet} {
    display: flex;
    flex-direction: column;
  }
`

export const StyledSearchForm = styled.form`
  position: relative;
  align-items: center;
  display: flex;
  max-height: ${pxToRem(60)};
  width: 100%;
  border-radius: ${({inputFocused}) =>
          inputFocused ? `${pxToRem(5)} ${pxToRem(5)} 0 0` : pxToRem(5)};
  padding: ${pxToRem(10)};
  background-color: ${({theme}) => theme.colors.unique.white};
  @media ${deviceMax.tablet} {
    padding: ${pxToRem(5)};
  }
`

export const StyledInput = styled.input`
  flex-grow: 1;
  margin-left: ${pxToRem(22)};
  border: initial;
  height: max-content;
  padding: ${pxToRem(10.5)} 0;
  font-size: ${({theme}) => theme.fonts.sizes.base};
  line-height: ${({theme}) => theme.fonts.lineHeight.base};
  font-weight: ${({theme}) => theme.fonts.weight.normal};
  @media ${deviceMax.tablet} {
    margin-left: ${pxToRem(15)};
  }
`

export const StyledSearchButton = styled(Button)`
  padding: ${pxToRem(10.5)} ${pxToRem(25)};
  white-space: nowrap;
  @media ${deviceMax.mobileL} {
    padding: ${pxToRem(2)};
  }
`

export const StyledButtonText = styled.p`
  display: flex;
  @media ${deviceMax.mobileL} {
    display: none;
  }
`

export const SearchIcon = styled(Search)`
  display: ${({$isMobile}) => ($isMobile ? 'none' : 'flex')};
  width: ${pxToRem(32)};
  height: ${pxToRem(32)};
  @media ${deviceMax.mobileL} {
    display: ${({$isMobile}) => ($isMobile ? 'flex' : 'none')};
  }
`

export const StyledInputContainer = styled.div`
  align-items: center;
  flex-grow: 1;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0 ${pxToRem(10)};
  background-color: ${({theme}) => theme.colors.unique.white};
  @media ${deviceMax.mobileL} {
    padding: 0 ${pxToRem(5)};
  }
`

export const StyledParagraph = styled.p`
  max-width: ${pxToRem(798)};
  padding-bottom: ${pxToRem(40)};
  font-size: ${({theme}) => theme.fonts.sizes.titleH3};
  line-height: ${({theme}) => theme.fonts.lineHeight.titleH3};
  font-weight: ${({theme}) => theme.fonts.weight.bold};
  text-align: center;
  color: ${({theme}) => theme.colors.unique.white};
`
